import { cropSrcSet, cropUrl } from '../../../utils/cropUrl'

/**
 * L'adresse d'affichage d'un média de la médiathèque, recadrée à la boîte
 * demandée par le point de terminaison `dynamic_image`.
 *
 * Une vignette de 320 px ne doit pas télécharger un original de 4000 px :
 * `cropUrl` compose `{cropBase}/{src}__{ops}.webp`, que le serveur web sert en
 * statique si le dérivé existe déjà, et que Drupal ne génère qu'une fois.
 * Les tailles sont quantifiées côté `cropUrl`, donc deux boîtes voisines
 * retombent sur le même fichier.
 *
 * Une source sans descripteur de recadrage (`src`/`cropBase` absents) est une
 * source que le module ne sait pas transformer — un SVG : on sert l'original.
 *
 * Vit dans son propre module (et non dans `MediaLibrary.jsx`) parce qu'un
 * export non-composant depuis un `.jsx` casse le Fast Refresh de Vite.
 *
 * @param {object|null} item  L'item de médiathèque.
 * @param {object} spec       `{op, w, h}` — la boîte demandée.
 * @returns {{src: string, srcSet?: string}}
 */
export const mediaDisplaySrc = (item, spec) => {
  if (!item) return { src: '' }
  if (!item.src || !item.cropBase) return { src: item.url ?? '' }
  return {
    src: cropUrl(item, spec, { ext: 'webp' }),
    srcSet: cropSrcSet(item, spec, { ext: 'webp', dprs: [1, 2] }),
  }
}
